import { useRef } from "react";
import { Link } from "react-router-dom";
import { BellIcon } from "@heroicons/react/outline";
import { CashIcon } from "@heroicons/react/solid";
import Notifications from "../components/Notif/Notifications";
import HeaderAvatar from "../components/Visual/HeaderAvatar";
import LayoutModeToggle from "../layout/LayoutModeToggle";
import { NAV_ITEMS } from "./navItems";

const DesktopTopBar = ({ headerData, pathname }) => {
  const {
    auth,
    credits,
    avatarUploaded,
    avatar,
    notifLength,
    showNotif,
    closeNotif,
    handleShowNotif,
    getSeen,
    notificationUpdates,
  } = headerData;
  const bell = useRef(null);
  const current = NAV_ITEMS.find((item) => item.match(pathname));

  return (
    <div className="ds-topbar">
      <div className="ds-topbar-title">{current?.label ?? ""}</div>
      <div id="ds-topbar-slot" className="ds-topbar-slot" />
      <div className="ds-topbar-actions">
        <LayoutModeToggle />
        <span className="ds-credits" title="Μονάδες">
          <CashIcon aria-hidden="true" />
          {credits >= 0 ? credits : 0}
        </span>
        <div className="ds-notif">
          <button
            ref={bell}
            type="button"
            className="ds-icon-btn"
            aria-label="Ενημερώσεις"
            title="Ενημερώσεις"
            onClick={() => {
              getSeen();
              handleShowNotif();
            }}
          >
            <BellIcon aria-hidden="true" />
            {notifLength > 0 && (
              <span className="ds-notif-count">
                {notifLength > 9 ? "9+" : notifLength}
              </span>
            )}
          </button>
          {showNotif && (
            <div className="ds-notif-popover notifications">
              <Notifications
                updates={notificationUpdates}
                notifLength={notifLength}
                handleShowNotif={handleShowNotif}
                closeNotif={closeNotif}
                bell={bell}
              />
            </div>
          )}
        </div>
        <Link to={`/profile/${auth?.uuid}`} className="ds-user">
          <HeaderAvatar
            uuid={auth?.uuid}
            avatarUploaded={avatarUploaded}
            avatar={avatar}
            userAvatar={auth?.avatar}
            avatarClass={"sm"}
          />
          <span>{auth?.user}</span>
        </Link>
      </div>
    </div>
  );
};

export default DesktopTopBar;
